import { useTranslation } from 'react-i18next';
import { LayoutDashboard } from 'lucide-react';

/**
 * Cross-links the main app to the partner dashboard at /partner, mirroring the
 * dashboard's own "Open Pyramida app" control. Uses the same LayoutDashboard
 * mark as the partner panel's app bar. The `--compact` variant (mobile header)
 * renders icon-only; `--block` (desktop sidebar) is full-width with the label.
 */
export function PartnerDashboardLink({ className }: { className?: string }) {
  const { t } = useTranslation();
  const label = t('partner.openDashboard');
  return (
    <a
      href="/partner"
      className={`partner-link${className ? ` ${className}` : ''}`}
      title={label}
      aria-label={label}
    >
      <LayoutDashboard size={16} aria-hidden="true" />
      <span className="partner-link__label">{label}</span>
    </a>
  );
}
